import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useParams } from "react-router-dom"
import { FIELD_OFFICER } from "../../../../../constants/InitTypeConstants.js"
import {
  clearDataForecast,
  deleteForecastData,
  getListFoBySubRegional,
  getMitraListSelector,
  initDataForecast,
  submitDataForecast
} from "../../../../../redux/actions/FieldOfficerAction.jsx"
import { fetchPlants } from "../../../../../redux/actions/MasterDataAction.jsx"
import { toast } from "react-toastify"
import { getLatestMonthNumberInitForecast } from "../../../../helpers/Utils.js"
import { KPI_GOAL_SETTING_TAB } from "../../../../../constants/StringConstant.js"

export function useTableInputForecast() {
  const param = useParams()
  const location = useLocation()

  const [showMitraPopup, setShowMitraPopup] = useState(false)
  const [targetFO, setTargetFO] = useState(undefined)
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const [loadingDelete, setLoadingDelete] = useState(false)
  const [data, setData] = React.useState([])
  const [mitraList, setMitraList] = useState(undefined)
  const [selectedMonth, setSelectedMonth] = useState(undefined)
  const [isMitraListLoading, setMitraListLoading] = useState(true)
  const [checkDisableButtonAddMonth, setCheckDisableButtonAddMonth] = useState(false)
  const [isFromHistory, setIsFromHistory] = useState(false)
  const [isInit, setIsInit] = useState(false)
  const dispatch = useDispatch()
  const { FieldOfficer, MasterData, General } = useSelector((state) => state)
  const dataInitForecast = FieldOfficer?.initForecast || []
  const loadingInitForecast = FieldOfficer?.loadingInitForecast
  const { id, year } = param
  const isThisYear = isNaN(Number(year)) && year === KPI_GOAL_SETTING_TAB.THIS_YEAR
  const plantList = MasterData?.plantList || []
  const [search, setSearch] = useState({ keyword: "" })
  const [isActiveSearch, setIsActiveSearch] = useState(false)
  const formMitraSearchRef = useRef()
  const dataFo = FieldOfficer?.listFoBySubRegional || []

  useEffect(() => {
    dispatch(clearDataForecast())
    setIsInit(false)
    setData([])
    dispatch(fetchPlants({
      use_metrics: true
    }))
    dispatch(getListFoBySubRegional(id))
    dispatch(
      initDataForecast(
        id,
        isNaN(Number(year)) && year === KPI_GOAL_SETTING_TAB.THIS_YEAR
          ? new Date().getFullYear()
          : year
      )
    )
  }, [id, year])

  useEffect(() => {
    setLoadingSubmit(
      General?.loading && General.actionInitType === FIELD_OFFICER.SUBMIT_DATA_FORECAST
    )
    setLoadingDelete(
      General?.loading && General.actionInitType === FIELD_OFFICER.DELETE_DATA_FORECAST
    )
  }, [General])

  useEffect(() => {
    const searchString = location.search
    const searchParams = new URLSearchParams(searchString)
    const history = searchParams.get("history")
    setIsFromHistory(!!history)
  }, [location.search])


  useEffect(() => {
    if (typeof targetFO !== "undefined") {
      const monthData = data.find((monthItem) => monthItem.month_number === targetFO.month)
      if (monthData) {
        setSelectedMonth(monthData)
        dispatch(getMitraListSelector(targetFO.fo))
      }
    }
  }, [targetFO, data])

  useEffect(() => {
    setMitraListLoading(true)
    resetMitraSearch()
    if (FieldOfficer.mitraListSelector) {
      let existingMitras = []
      if (selectedMonth) {
        if (targetFO) {
          const foData = selectedMonth.fieldOfficers.find((foItem) => foItem.id === targetFO.fo)
          if (foData) {
            existingMitras = foData.mitras
              .filter((mitraItem) => mitraItem.id !== "")
              .map((mitraFilteredItem) => mitraFilteredItem.mitra_id)
            setMitraList(
              FieldOfficer.mitraListSelector
                .map((mitraListItem) => {
                  return {
                    ...mitraListItem,
                    mitra_id: mitraListItem.id,
                    selected: existingMitras.includes(mitraListItem.id),
                    isAlreadySelected: existingMitras.includes(mitraListItem.id)
                  }
                })
                .sort((first, last) => last.isAlreadySelected - first.isAlreadySelected)
            )
          }
        }
      }
      setMitraListLoading(false)
    }
  }, [FieldOfficer.mitraListSelector])

  function generateRawMitras(isInitial) {
    return [
      {
        id: "",
        name: "",
        seq: 0,
        isInitial,
        forecast: generateForecastData()
      }
    ]
  }

  function onClickAddMonth() {
    const copiedData = [...data]
    const latestData = [...copiedData].reverse()[0]

    const newMonthNumber = latestData.month_number + 1
    const newData = {
      ...latestData,
      name: getMonthName(newMonthNumber),
      month_number: newMonthNumber,
      fieldOfficers: latestData.fieldOfficers.map((e) => ({
        ...e,
        mitras: generateRawMitras(true)
      }))
    }

    if (!checkDisableButtonAddMonth) {
      setData([...copiedData, newData])
    }
  }

  const sumDataMitras = React.useMemo(() => {
    return (fo) => {
      const forecast = (fo.mitras || []).map((e) => e?.forecast)
      const resultMap = new Map()

      forecast.flat().forEach((item) => {
        if (!item?.plant_type_id) return
        if (!resultMap.has(item.plant_type_id)) {
          resultMap.set(item.plant_type_id, { ...item })
        } else {
          resultMap.get(item.plant_type_id).value += item.value
        }
      })

      return Array.from(resultMap.values())
    }
  }, [data])

  function getMonthName(monthNumber) {
    const month = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember"
    ]
    return month[monthNumber]
  }

  function generateForecastData() {
    if (plantList && plantList.length > 0) {
      return plantList.map((e) => {
        return {
          plant_type_id: e?.id,
          label: e?.name,
          value: 0
        }
      })
    }
  }

  function getMaxMonthCount(monthNumbers) {
    const forecastMax = getLatestMonthNumberInitForecast(monthNumbers)
    return Math.max(forecastMax, 3)
  }

  useEffect(() => {
    if (isInit) {
      return
    }

    if (dataFo.length > 0 && !loadingInitForecast) {
      const monthNumbers = dataInitForecast?.map((e) => e.month_number) || []
      const totalMonths = getMaxMonthCount(monthNumbers)

      const generatedData = Array.from({ length: totalMonths }).map((_, i) => ({
        month_number: i,
        name: getMonthName(i),
        fieldOfficers: dataFo.map((fo) => ({
          id: fo.id,
          name: fo.name,
          mitras: generateRawMitras(true)
        }))
      }))

      setData(generatedData)
    } else if (dataFo.length === 0 && !isInit) {
      setData([])
    }
  }, [dataFo, loadingInitForecast, dataInitForecast, isInit])

  useEffect(() => {
    if (!isInit &&
      dataInitForecast?.length > 0 &&
      data.length > 0 &&
      !loadingInitForecast &&
      plantList?.length > 0) {
      handleInitForecast()
      setIsInit(true)
    }
  }, [dataInitForecast, data, loadingInitForecast, plantList, isInit])

  function handleInitForecast() {
    if (!dataInitForecast || dataInitForecast.length === 0) return

    const updatedData = data.map((monthData) => {
      const updatedFieldOfficers = monthData.fieldOfficers.map((fo) => {
        const relatedForecasts = dataInitForecast.filter(
          (entry) => entry.fo_id === fo.id && entry.month_number === monthData.month_number
        )

        const mitraMap = new Map()

        fo.mitras
          .filter(mitra => mitra.id !== "")
          .forEach((mitra) => {
            mitraMap.set(mitra.mitra_id, mitra)
          })

        relatedForecasts.forEach((e) => {
          if (!mitraMap.has(e.mitra_id)) {
            mitraMap.set(e.mitra_id, {
              id: e.id,
              mitra_id: e.mitra_id,
              name: e.mitra_name,
              seq: 0,
              isInitial: false,
              forecast: plantList.map((plantItem) => {
                const foundForecast = e.forecast.find((f) => f.plant_type_id === plantItem.id)
                return {
                  plant_type_id: plantItem.id,
                  label: plantItem.name,
                  value: foundForecast && foundForecast.value !== undefined ? foundForecast.value : 0
                }
              }) || []
            })
          }
        })

        const updatedMitras = Array.from(mitraMap.values())

        updatedMitras.forEach((mitra, index) => {
          mitra.seq = index + 1
        })

        if (updatedMitras.length === 0) {
          updatedMitras.push(...generateRawMitras(true))
        }

        return { ...fo, mitras: updatedMitras }
      })

      return { ...monthData, fieldOfficers: updatedFieldOfficers }
    })

    setData(updatedData)
  }

  function handleAddMitra() {
    const monthId = targetFO?.month
    const foId = targetFO?.fo
    if (mitraList.filter((mitra) => mitra.selected).length === 0) {
      setMitraList(undefined)
      setTargetFO(undefined)
      return
    }

    setData((prevData) =>
      prevData.map((prevMonth) => {
        if (prevMonth.month_number === monthId) {
          return {
            ...prevMonth,
            fieldOfficers: prevMonth.fieldOfficers.map((prevFO) => {
              if (prevFO.id === foId) {
                const existingMitraIds = new Set(
                  prevFO.mitras
                    .filter(m => m.mitra_id && m.mitra_id !== "")
                    .map(m => m.mitra_id)
                )

                const nonEmptyMitras = prevFO.mitras.filter(m => m.id !== "")
                const nextSeq = nonEmptyMitras.length > 0
                  ? Math.max(...nonEmptyMitras.map(m => m.seq)) + 1
                  : 1

                const newMitras = mitraList
                  .filter((mitraListItem) => mitraListItem.selected)
                  .filter((mitraListItem) => !existingMitraIds.has(mitraListItem.id))
                  .map((mitra, index) => {
                    return {
                      ...mitra,
                      seq: nextSeq + index,
                      forecast: generateForecastData()
                    }
                  })

                return {
                  ...prevFO,
                  mitras: nonEmptyMitras.length > 0
                    ? [...nonEmptyMitras, ...newMitras]
                    : newMitras.length > 0
                      ? newMitras
                      : generateRawMitras(true)
                }
              } else {
                return prevFO
              }
            })
          }
        } else {
          return prevMonth
        }
      })
    )

    setMitraList(undefined)
    setTargetFO(undefined)
  }

  const onMitraCheckChange = (_event, mitraListItem) => {
    if (!mitraListItem.isAlreadySelected) {
      setMitraList((mitraCheck) => {
        return mitraCheck.map((mitraCheckItem) => {
          if (mitraCheckItem.id === mitraListItem.id) {
            return { ...mitraCheckItem, selected: !mitraCheckItem.selected }
          } else {
            return mitraCheckItem
          }
        })
      })
    }
  }

  function onChangeValue(e, v, isBlur) {
    const newValue = parseFloat(e?.target?.value || "0")
    const monthNumber = v?.month?.month_number
    const fieldOfficerId = v?.fo
    const mitraId = v?.mitra?.mitra_id
    const plantTypeId = v.key
    let mitraEdited = undefined

    const parseData = data.map((month) => {
      if (month.month_number !== monthNumber) return month
      return {
        ...month,
        fieldOfficers: month.fieldOfficers.map((fo) => {
          if (fo.id !== fieldOfficerId) return fo
          return {
            ...fo,
            mitras: fo.mitras.map((mitra) => {
              if (mitra.mitra_id !== mitraId) return mitra

              const newMitra = {
                ...mitra,
                forecast: mitra.forecast.map((f) =>
                  f.plant_type_id === plantTypeId ? { ...f, value: newValue } : f
                )
              }
              mitraEdited = newMitra
              return newMitra
            })
          }
        })
      }
    })
    setData(parseData)
    if (isBlur) {
      if (mitraEdited.mitra_id) {
        const payloadData = {
          month_number: monthNumber,
          year:
            isNaN(Number(year)) && year === KPI_GOAL_SETTING_TAB.THIS_YEAR
              ? new Date().getFullYear()
              : year,
          sub_regional_id: id,
          fo_id: fieldOfficerId,
          mitra_id: mitraEdited.mitra_id,
          mitra_seq: mitraEdited?.seq,
          forecast: mitraEdited?.forecast
        }
        dispatch(submitDataForecast(payloadData))
      } else {
        toast.error("Terdapat Parameter yang kosong")
      }
    }
  }

  const onMitraSearch = (value) => {
    setSearch({ keyword: value.keyword })
    setIsActiveSearch(true)
  }

  const resetMitraSearch = () => {
    setSearch({ keyword: "" })
    setIsActiveSearch(false)
  }

  const removeMitraFromFO = (monthNumber, foId, mitraId, forecastId = undefined) => {
    setData((prevData) =>
      prevData.map((prevMonth) => {
        if (prevMonth.month_number === monthNumber) {
          return {
            ...prevMonth,
            fieldOfficers: prevMonth.fieldOfficers.map((prevFO) => {
              if (prevFO.id === foId) {
                if (typeof forecastId !== "undefined") {
                  dispatch(deleteForecastData(forecastId))
                }

                const filteredMitras = prevFO.mitras.filter((prevMitra) => prevMitra.id !== forecastId)

                const updatedMitras = filteredMitras.length === 0
                  ? generateRawMitras(true)
                  : filteredMitras

                return {
                  ...prevFO,
                  mitras: updatedMitras
                }
              } else {
                return prevFO
              }
            })
          }
        } else {
          return prevMonth
        }
      })
    )
  }

  useEffect(() => {
    if (formMitraSearchRef.current) {
      if (formMitraSearchRef.current?.values?.keyword === "") resetMitraSearch()
    }
  }, [formMitraSearchRef.current?.values])
  function checkDisableInputForecast(year, disable) {
    if (disable) {
      return true
    } else {
      return isFromHistory
    }
  }

  useEffect(() => {
    const arrMonthNum = data.map((e) => e.month_number)
    const num = getLatestMonthNumberInitForecast(arrMonthNum)
    setCheckDisableButtonAddMonth(num === 12)
  }, [data])

  return {
    data,
    setData,
    checkDisableButtonAddMonth,
    handleAddMitra,
    sumDataMitras,
    loadingSubmit,
    onClickAddMonth,
    onChangeValue,
    showMitraPopup,
    setShowMitraPopup,
    targetFO,
    setTargetFO,
    mitraList,
    onMitraCheckChange,
    isMitraListLoading,
    setSearch,
    search,
    isActiveSearch,
    setIsActiveSearch,
    formMitraSearchRef,
    resetMitraSearch,
    onMitraSearch,
    removeMitraFromFO,
    loadingDelete,
    year,
    checkDisableInputForecast,
    isFromHistory,
    isThisYear,
    loadingInitForecast,
    plantList
  }
}
